const ja = {
  risk: {
    riskTitle: "リスク注文管理",
    tips1: "あなたが持っている",
    tips2: "どの注文にもリスクはあります。取引開始後 7 日以内にカード所有者に確認のためご連絡ください。有効期限が切れた場合、取引は自動的にキャンセルされます。 pingpong がそれを完了するのに役立ちます。",
    tipsNoPermission: "リスクの高い注文の場合、PingPong はリスクを検討して決定を下します。ご不明な点がございましたら、お問い合わせください。ご理解いただきありがとうございます。",
    emptyText: "現在リスク注文はありません"
  },
  table: {
    tradingTime: "取引日時",
    storeName: "Webサイト",
    omniStoreName: "店舗 / ウェブサイト名",
    groupName: "グループ",
    outFlowId: "取引番号",
    currency: "取引通貨",
    payBrand: "支払方法",
    amount: "取引金額",
    type: "取引タイプ",
    status: "取引状況",
    action: "操作",
    detail: "詳細"
  }
};
export default ja;